import { render, staticRenderFns } from "./ItemListDialog.vue?vue&type=template&id=66e8d122"
import script from "./ItemListDialog.vue?vue&type=script&lang=js"
export * from "./ItemListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports